<template>
  <div></div>
</template>

<script>
export default {
  name: 'VerifyAdminOrderRecipients',

  created() {
    this.handleVerification()
  },

  methods: {
    async handleVerification() {
      const { uuid, token } = this.$route.query
      await this.$store.dispatch('project/getProjectLinkInfo', {
        projectId: uuid
      })

      await this.$store.dispatch('project/verifyAdminOrderRecipient', {
        uuid,
        token
      })
    }
  }
}
</script>
